import { MatTableDataSource } from '@angular/material/table';
import { MatrixRowModel } from './templatesModels/matrix-row-model';
import { UserMatrixRowModel } from './user-matrix-row-model';

export class UserMatrixModel {
    userMatrixId: string;
    name: string;
    usage: number;
    userMatrixRows: UserMatrixRowModel[];
    userMatrixRowId: string;
    userMatrixRowsMatTable: MatTableDataSource<MatrixRowModel>;
}
